export default function () {
  return {
    selectedNode: null,
    wikiMeta: {},
    historyCategory: {
      id: 0,
      name: ''
    },
    categoryDeleteGlobally: {
      id: 0,
      name: '',
      childrenCount: 0
    },
    deletedCategory: {
      id: 0
    },
    isDeletingGloballyActive: false
  };
}